import { AffiliateReport } from "components/Report/AffiliateReport/AffiliateReport.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import {usePaldockTranslation} from "hooks/usePaldockTranslation";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getReportHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/report/_layout/affiliate/")({
    component: AffiliatesReportPage,
    staticData: {
        permissions: [PermissionEnum.ReportAffiliate],
        showInSideMenu: false,
        label: "pages.report.affiliate.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.report.affiliate.title"),
        };
    },
});

function AffiliatesReportPage() {
    const { t } = usePaldockTranslation("pages.report.affiliate");
    return (
        <TenantPage headerNavigationItems={getReportHeaderItems} title={t("title")}>
            <AffiliateReport />
        </TenantPage>
    );
}
